import { render, staticRenderFns } from "./DriverDelivery.vue?vue&type=template&id=77bcd88c&scoped=true"
import script from "./DriverDelivery.vue?vue&type=script&lang=js"
export * from "./DriverDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bcd88c",
  null
  
)

export default component.exports